import { Button } from "react-bootstrap";
import "../../../App.css";
import { useState, useEffect } from "react";
import Receipt from "./Receipt";
import axios from "axios";
import { getGlobalVar, setGlobalVar } from "../../config/Config";
import { CloseOutlined } from "@ant-design/icons";

const Payment = ({
  setPayPopup,
  total,
  prevOrder,
  itemsInCart,
  currentCustomer,
  payPopup,
  currentOrderRef,
  setItemsInCart,
}) => {
  const baseurl = getGlobalVar().url;
  const USER = JSON.parse(localStorage.getItem("auth"));
  const org = "?org=" + USER.org;
  const API_URL = baseurl + "/posapi/GetOrder/";
  const paymentAPI = baseurl + "/posapi/GetPayment/";
  const [regValcash, setRegValcash] = useState("");
  const [regValcard, setRegValcard] = useState("");
  const [regValcredit, setRegValcredit] = useState("");
  const [rem, setRem] = useState(0);
  const [change, setChange] = useState(0);
  const [validatePopup, setValidatePopup] = useState(false);
  const [orderValidate, setOrderValidate] = useState([]);
  const [showBill, setShowBill] = useState(false);
  const [cash, setCash] = useState("");
  const [globalVar, setValue] = useState(getGlobalVar());

  // selectors state
  const [payStatecash, setPayStatecash] = useState(false);
  const [payStatecard, setPayStatecard] = useState(false);
  const [payStatecredit, setPayStatecredit] = useState(false);
  const [activepayState, setactivePayState] = useState("");

  const [payment, setPayment] = useState({
    cash: 0,
    card: 0,
    credit: 0,
  });

  // ON VALIDATE CLICK
  const onValidate = async () => {
    if (itemsInCart.length > 0 && currentCustomer && rem <= 0) {
      // const newOrder = {
      //   order_id: prevOrder.length + 1,
      //   customer: { ...currentCustomer },
      //   order: [...itemsInCart],
      // };

      // Save the new order in the state
      // setOrderValidate([...prevOrder, newOrder]);
      // setShowBill(true);
      const actualOrderId = localStorage.getItem("actualOrderId");

      try {
        const response = await axios.patch(
          `${API_URL}${actualOrderId}/`,
          {
            status: true,
            org: USER.org,
          },
          {
            headers: {
              Authorization: "Token " + globalVar.Token,
            },
          }
        );

        console.log("Order status updated successfully:", response.data);
        setShowBill(true);
      } catch (error) {
        console.error("Error updating order status:", error);
      }
    } else {
      if (itemsInCart.length == 0) {
        alert("Add Items In a Cart ");
      } else if (!currentCustomer) {
        alert("Set Customer");
      } else if (rem > 0) {
        alert("No Remaining Amount");
      }
    }
  };

  //   On register entry
  const onCalcBtnClick = (e) => {
    if (e.target.name == "plus") {
      console.log("plus minus");
    } else {
      if (activepayState == "cash") {
        setRegValcash((prev) => {
          let regVal2 = prev.concat(e.target.name);
          // setCash(regVal2);
          return regVal2;
        });
      }
      if (activepayState == "card") {
        setRegValcard((prev) => {
          let regVal2 = prev.concat(e.target.name);
          // setCash(regVal2);
          return regVal2;
        });
      }
      if (activepayState == "credit") {
        setRegValcredit((prev) => {
          let regVal2 = prev.concat(e.target.name);
          // setCash(regVal2);
          return regVal2;
        });
      }
    }
  };

  // On cross button
  const onBackspace = () => {
    if (activepayState == "cash") {
      setRegValcash("");
    }
    if (activepayState == "card") {
      setRegValcard("");
    }
    if (activepayState == "credit") {
      setRegValcredit("");
    }
    // setRegVal("");
    setRem("");
  };

  useEffect(() => {
    const totalregVal =
      Number(regValcash) + Number(regValcard) + Number(regValcredit);
    setRem(total - totalregVal);
    setChange(totalregVal - total);
    // let remaining = total-regVal;
  }, [total, regValcash, regValcard, regValcredit]);

  return (
    <div className="pay-popup ">
      {/* RECEIPT */}
      {showBill ? (
        <Receipt
          regValcash={regValcash}
          regValcard={regValcard}
          regValcredit={regValcredit}
          total={total}
          change={change}
          orderValidate={orderValidate}
          currentOrderRef={currentOrderRef}
          setShowBill={setShowBill}
          itemsInCart={itemsInCart}
          currentCustomer={currentCustomer}
          setPayPopup={setPayPopup}
          setItemsInCart={setItemsInCart}
        />
      ) : (
        ""
      )}
      <div className="cancel-validate flex justify-between bg-gray-300">
        <Button
          variant="danger"
          onClick={() => {
            setPayPopup(false);
          }}
        >
          Cancel
        </Button>
        <Button className="xb" variant="success" onClick={onValidate}>
          Validate
        </Button>
      </div>

      <div className="row">
        <div className="col-3 border-right mt-5">
          <div className="row ml-2 px-5">
            <Button
              className={`col-12 bx mt-2 ${
                activepayState == "cash" ? "pay-type" : ""
              } `}
              onClick={() => {
                setPayStatecash(true);
                setactivePayState("cash");
              }}
            >
              {" "}
              Cash
            </Button>
            <Button
              className={`col-12 bx mt-2 ${
                activepayState == "card" ? "pay-type" : ""
              } `}
              onClick={() => {
                setPayStatecard(true);
                setactivePayState("card");
              }}
            >
              {" "}
              Card
            </Button>
            <Button
              className={`col-12 bx mt-2 ${
                activepayState == "credit" ? "pay-type" : ""
              } `}
              onClick={() => {
                setPayStatecredit(true);
                setactivePayState("credit");
              }}
            >
              {" "}
              Credit
            </Button>
          </div>
        </div>
        <div className="col-9">
          {payStatecash || payStatecard || payStatecredit ? (
            <div className="row">
              <div className="col-10 px-5 mt-5" style={{ height: "200px" }}>
                <table className="table table-bordered table-striped border  ">
                  <thead>
                    <tr>
                      <th>Payment Type </th> <th>Amount </th>
                      <th>Remove</th>
                    </tr>
                  </thead>
                  <tbody>
                    {payStatecash ? (
                      <tr>
                        <td>Cash </td> <td> {Number(regValcash)} </td>
                        <td>
                          <Button
                            variant="danger"
                            onClick={() => {
                              setPayStatecash(false);
                              setRegValcash("0");
                            }}
                          >
                            <CloseOutlined />
                          </Button>
                        </td>
                      </tr>
                    ) : (
                      ""
                    )}
                    {payStatecard ? (
                      <tr>
                        <td>Card </td> <td>{Number(regValcard)} </td>
                        <td>
                          <Button
                            variant="danger"
                            onClick={() => {
                              setPayStatecard(false);
                              setRegValcard("0");
                            }}
                          >
                            <CloseOutlined />
                          </Button>
                        </td>
                      </tr>
                    ) : (
                      ""
                    )}
                    {payStatecredit ? (
                      <tr>
                        <td>Credit </td> <td>{Number(regValcredit)} </td>
                        <td>
                          <Button
                            variant="danger"
                            onClick={() => {
                              setPayStatecredit(false);
                              setRegValcredit("0");
                            }}
                          >
                            <CloseOutlined />
                          </Button>
                        </td>
                      </tr>
                    ) : (
                      ""
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          ) : (
            <div className="cash-rem-chg flex flex-col sixe">
              <span>{Number(total)}</span>
            </div>
          )}

          <div className="row black border-bottom">
            <div className="col-4">
              <b>Total: {Number(total)}</b>
              <p>
                {" "}
                <b>
                  Change : {change > 0 ? Number(change.toFixed(2)) : "0"}
                </b>{" "}
              </p>
            </div>
            <div className="col-4 leftx">
              {" "}
              <b>Remaining: {rem > 0 ? Number(rem.toFixed(2)) : "0"}</b>
            </div>
          </div>
        </div>
      </div>
      <div className="row mt-3">
        <div className="col-3"></div>
        <div className="col-5">
          {/* Cash Register */}
          <div className="lower flex ">
            <div className="cash-register">
              <div className="calculator register">
                <button name="1" onClick={onCalcBtnClick}>
                  {" "}
                  1{" "}
                </button>
                <button name="2" onClick={onCalcBtnClick}>
                  {" "}
                  2{" "}
                </button>
                <button name="3" onClick={onCalcBtnClick}>
                  {" "}
                  3{" "}
                </button>
                <button
                  onClick={() => {
                    if (activepayState == "cash") {
                      setRegValcash((prev) => {
                        let a = Number(regValcash) + 10;
                        return a.toString();
                      });
                    }
                    if (activepayState == "card") {
                      setRegValcard((prev) => {
                        let a = Number(regValcard) + 10;
                        return a.toString();
                      });
                    }
                    if (activepayState == "credit") {
                      setRegValcredit((prev) => {
                        let a = Number(regValcredit) + 10;
                        return a.toString();
                      });
                    }

                    // setRegVal((prev) => {
                    //   let a = Number(regVal) + 10;
                    //   return a.toString();
                    // });
                  }}
                  name="QTY"
                >
                  +10
                </button>
                <button name="4" onClick={onCalcBtnClick}>
                  {" "}
                  4{" "}
                </button>
                <button name="5" onClick={onCalcBtnClick}>
                  {" "}
                  5{" "}
                </button>
                <button name="6" onClick={onCalcBtnClick}>
                  {" "}
                  6{" "}
                </button>
                <button
                  name=""
                  onClick={() => {
                    if (activepayState == "cash") {
                      setRegValcash((prev) => {
                        let a = Number(regValcash) + 20;
                        return a.toString();
                      });
                    }
                    if (activepayState == "card") {
                      setRegValcard((prev) => {
                        let a = Number(regValcard) + 20;
                        return a.toString();
                      });
                    }
                    if (activepayState == "credit") {
                      setRegValcredit((prev) => {
                        let a = Number(regValcredit) + 20;
                        return a.toString();
                      });
                    }
                  }}
                >
                  +20
                </button>
                <button name="7" onClick={onCalcBtnClick}>
                  {" "}
                  7{" "}
                </button>
                <button name="8" onClick={onCalcBtnClick}>
                  {" "}
                  8{" "}
                </button>
                <button name="9" onClick={onCalcBtnClick}>
                  {" "}
                  9{" "}
                </button>
                <button
                  onClick={() => {
                    if (activepayState == "cash") {
                      setRegValcash((prev) => {
                        let a = Number(regValcash) + 50;
                        return a.toString();
                      });
                    }
                    if (activepayState == "card") {
                      setRegValcard((prev) => {
                        let a = Number(regValcard) + 50;
                        return a.toString();
                      });
                    }
                    if (activepayState == "credit") {
                      setRegValcredit((prev) => {
                        let a = Number(regValcredit) + 50;
                        return a.toString();
                      });
                    }
                  }}
                  name=""
                >
                  +50
                </button>
                <button name="plus" onClick={onCalcBtnClick}>
                  {" "}
                  +/-{" "}
                </button>
                <button name="0" onClick={onCalcBtnClick}>
                  {" "}
                  0{" "}
                </button>
                <button name="." onClick={onCalcBtnClick}>
                  {" "}
                  .{" "}
                </button>
                <button name="" onClick={onBackspace}>
                  {" "}
                  X{" "}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="col-4">
          <div className="customer-invoice">
            <button className="xb">
              {" "}
              {currentCustomer && typeof currentCustomer === "object"
                ? `${currentCustomer.first_name}`
                : currentCustomer
                ? `${currentCustomer}`
                : "No Customer"}
            </button>
            <br />
            <button className="xb mt-3">Invoice</button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Payment;
